import { reducer as problemReport } from "./problem-report/slice";

export const reducer = {
  problemReport,
};
